import(/* webpackMode: "eager", webpackExports: ["default"] */ "C:\\Users\\remar\\Desktop\\Klaudo Fabrikas\\žaidimuks\\siaubozaidimas\\src\\app\\components\\LandingScreen.tsx");
